interface LogoProps {
  className?: string;
}

export function SP500TrackerLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M11.2,30.3c-.8-.2-1.5-.6-2-1l.9-2c.5.4,1.1.6,1.7.9.7.2,1.3.3,2,.3s1.3-.1,1.7-.3.5-.5.5-.9-.1-.5-.3-.7-.5-.3-.8-.4c-.3-.1-.8-.2-1.3-.4-.9-.2-1.6-.4-2.1-.6-.6-.2-1-.5-1.4-1-.4-.5-.6-1.1-.6-1.8s.2-1.3.5-1.8c.4-.5.9-1,1.6-1.3.7-.3,1.6-.5,2.6-.5s1.4,0,2.1.3,1.3.4,1.8.8l-.8,2c-1-.6-2.1-.9-3.2-.9s-1.3.1-1.6.4c-.4.2-.5.5-.5.9s.2.7.6.9,1,.4,1.9.6c.9.2,1.6.4,2.1.6.5.2,1,.5,1.4,1,.4.4.6,1,.6,1.8s-.2,1.2-.5,1.8c-.4.5-.9,1-1.6,1.3-.7.3-1.6.5-2.6.5s-1.8-.1-2.6-.4h0Z" 
      />
      <path 
        fill="currentColor" 
        d="M29.2,30.7l-1.4-1.3c-1.1.9-2.4,1.3-3.8,1.3s-1.6-.1-2.2-.4-1.2-.6-1.5-1.1c-.4-.5-.6-1-.6-1.6s.2-1.3.6-1.9c.4-.5,1-1,1.9-1.5-.4-.4-.7-.8-.9-1.2s-.3-.8-.3-1.2.1-1,.4-1.5c.3-.4.7-.8,1.2-1,.5-.2,1.2-.4,1.9-.4,1,0,1.8.2,2.4.7s.9,1.1.9,1.9-.2,1.1-.5,1.6c-.4.5-.9.9-1.7,1.3l2.1,1.9c.2-.5.4-1.1.6-1.8l2,.6c-.2,1-.6,1.9-1,2.6l1.3,1.2-1.4,1.6h0ZM26.3,28l-2.8-2.6c-.5.3-.9.6-1.1.9s-.3.6-.3,1,.2.8.5,1c.4.3.9.4,1.5.4s1.5-.2,2.1-.7h0ZM23.7,21c-.2.2-.3.4-.3.8s0,.4.2.6c.1.2.4.5.7.8.5-.3.9-.6,1.2-.8.2-.2.3-.5.3-.8s-.1-.5-.3-.7c-.2-.2-.5-.3-.8-.3s-.7.1-.9.3h0Z" 
      />
      <path 
        fill="currentColor" 
        d="M39.8,19.6c.7.3,1.3.8,1.7,1.4.4.6.6,1.4.6,2.2s-.2,1.6-.6,2.2c-.4.6-1,1.1-1.7,1.4-.7.3-1.6.5-2.6.5h-2.3v3.1h-2.6v-11.4h4.9c1,0,1.9.2,2.6.5ZM38.9,24.7c.4-.3.6-.8.6-1.5s-.2-1.1-.6-1.5-1-.5-1.8-.5h-2.2v4h2.2c.8,0,1.4-.2,1.8-.5Z" 
      />
      <path 
        fill="currentColor" 
        d="M25,47.3c-12.3,0-22.3-10-22.3-22.3S12.7,2.7,25,2.7s22.3,10,22.3,22.3-10,22.3-22.3,22.3ZM25,4.3C13.6,4.3,4.3,13.6,4.3,25s9.3,20.7,20.7,20.7,20.7-9.3,20.7-20.7S36.4,4.3,25,4.3Z" 
      />
    </svg>
  );
}